<div class="modal-header">
  <h5 class="modal-title">Visualizar projeto</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="dismiss()"
  ></button>
</div>

<div class="modal-body" [formGroup]="viewForm">
  <div class="mb-3">
    <div class="row align-items-end g-2">
      <div class="col-md-8">
        <label class="form-label">ID da Conta</label>
        <input
          type="text"
          class="form-control"
          [value]="accountGuid || '-'"
          readonly
        />
      </div>

      <div class="col-md-4">
        <button
          type="button"
          class="btn btn-pill btn-primary w-100"
          (click)="copyGuid()"
          [disabled]="!accountGuid"
        >
          <i class="fe fe-copy me-2"></i>Copiar ID
        </button>
      </div>
    </div>
  </div>

  <div class="mb-3">
    <div class="row g-3">
      <div class="col-md-6">
        <label class="form-label">Data de Cadastro</label>
        <input
          type="text"
          class="form-control"
          [value]="
            insertDate
              ? (insertDate | date: 'dd/MM/yyyy HH:mm:ss' : '-0300')
              : '-'
          "
          readonly
        />
      </div>

      <div class="col-md-6">
        <label class="form-label">Última Atualização</label>
        <input
          type="text"
          class="form-control"
          [value]="
            updateDate
              ? (updateDate | date: 'dd/MM/yyyy HH:mm:ss' : '-0300')
              : '-'
          "
          readonly
        />
      </div>
    </div>
  </div>

  <mat-accordion [multi]="false">
    <mat-expansion-panel
      [expanded]="isProjectExpanded"
      (opened)="openSection('project')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Dados do Projeto</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-3" formGroupName="operatorRegistration">
        <div class="col-md-6">
          <label class="form-label">Nome do Projeto</label>
          <input
            type="text"
            class="form-control"
            formControlName="nameProject"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label">Site</label>
          <input
            type="text"
            class="form-control"
            formControlName="site"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label">Licenciamento</label>
          <input
            type="text"
            class="form-control"
            [value]="licensingLabel(licensingId)"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label">Banco</label>
          <input
            type="text"
            class="form-control"
            formControlName="bankProvider"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label">Plataforma</label>
          <input
            type="text"
            class="form-control"
            formControlName="currentPlatform"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label">Percentual GGR</label>
          <input
            type="number"
            class="form-control"
            formControlName="percentGGR"
            readonly
          />
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="isCompanyExpanded"
      (opened)="openSection('company')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Empresa</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-3" formGroupName="company">
        <div class="col-md-4">
          <label class="form-label">CNPJ</label>
          <input
            type="text"
            class="form-control"
            formControlName="cnpj"
            mask="CPF_CNPJ"
            readonly
          />
        </div>

        <div class="col-md-8">
          <label class="form-label">Razão Social</label>
          <input
            type="text"
            class="form-control"
            formControlName="razaoSocial"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label">Email</label>
          <input
            type="text"
            class="form-control"
            formControlName="email"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label">Telefone</label>
          <input
            type="text"
            class="form-control"
            formControlName="phone"
            readonly
          />
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="isAddressExpanded"
      (opened)="openSection('address')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Endereço</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-3" formGroupName="adress">
        <div class="col-md-6">
          <label class="form-label">Logradouro</label>
          <input
            type="text"
            class="form-control"
            formControlName="logradouro"
            readonly
          />
        </div>

        <div class="col-md-2">
          <label class="form-label">Número</label>
          <input
            type="text"
            class="form-control"
            formControlName="numero"
            readonly
          />
        </div>

        <div class="col-md-4">
          <label class="form-label">Complemento</label>
          <input
            type="text"
            class="form-control"
            formControlName="complemento"
            readonly
          />
        </div>

        <div class="col-md-3">
          <label class="form-label">CEP</label>
          <input
            type="text"
            class="form-control"
            formControlName="cep"
            readonly
          />
        </div>

        <div class="col-md-3">
          <label class="form-label">Bairro</label>
          <input
            type="text"
            class="form-control"
            formControlName="bairro"
            readonly
          />
        </div>

        <div class="col-md-4">
          <label class="form-label">Cidade</label>
          <input
            type="text"
            class="form-control"
            formControlName="cidade"
            readonly
          />
        </div>

        <div class="col-md-2">
          <label class="form-label">Estado</label>
          <input
            type="text"
            class="form-control"
            formControlName="estado"
            readonly
          />
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="isSponsorExpanded"
      (opened)="openSection('sponsor')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Responsável</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-3" formGroupName="sponsor">
        <div class="col-md-4">
          <label class="form-label">CPF</label>
          <input
            type="text"
            class="form-control"
            formControlName="cpf"
            mask="CPF_CNPJ"
            readonly
          />
        </div>

        <div class="col-md-8">
          <label class="form-label">Nome</label>
          <input
            type="text"
            class="form-control"
            formControlName="name"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label">Email</label>
          <input
            type="text"
            class="form-control"
            formControlName="email"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label">Telefone</label>
          <input
            type="text"
            class="form-control"
            formControlName="phone"
            readonly
          />
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="isFinancialExpanded"
      (opened)="openSection('financial')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Limites Financeiros</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label">Depósito (Por transação) - Mínimo</label>
          <input
            type="text"
            class="form-control"
            formControlName="depositValueMinRequest"
            currencyMask
            [options]="{ prefix: 'R$ ', allowNegative: false }"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label">Depósito (Por transação) - Máximo</label>
          <input
            type="text"
            class="form-control"
            formControlName="depositValueMaxRequest"
            currencyMask
            [options]="{ prefix: 'R$ ', allowNegative: false }"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label"
            >Limite de Saque Automático (Por transação)</label
          >
          <input
            type="text"
            class="form-control"
            formControlName="valorMinimoSaqueAutomatico"
            currencyMask
            [options]="{ prefix: 'R$ ', allowNegative: false }"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label"
            >Quantidade de Saque em 24h (Por recebedor)</label
          >
          <input
            type="number"
            class="form-control"
            formControlName="amountExpired"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label"
            >Limite de Saque em 24h (Por recebedor)</label
          >
          <input
            type="text"
            class="form-control"
            formControlName="valueExpired"
            currencyMask
            [options]="{ prefix: 'R$ ', allowNegative: false }"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label d-block"
            >Cancelamento Automático de Saque</label
          >
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.analyzeWithdrawal.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-6">
          <label class="form-label">Saque (Por transação) - Mínimo</label>
          <input
            type="text"
            class="form-control"
            formControlName="valueMinRequest"
            currencyMask
            [options]="{ prefix: 'R$ ', allowNegative: false }"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label">Saque (Por transação) - Máximo</label>
          <input
            type="text"
            class="form-control"
            formControlName="valueMaxRequest"
            currencyMask
            [options]="{ prefix: 'R$ ', allowNegative: false }"
            readonly
          />
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="isPermissionsExpanded"
      (opened)="openSection('permissions')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Permissões</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label d-block">Permissão Saque</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.permissonWithdraw.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block">Permissão Depósito</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.permissonDeposit.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block">Permissão TEF</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.permissonTef.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block">Permissão Crypto</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.permissonCrypto.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block">Permission Game API</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.permissionGameApi.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block">Bloqueio de Jogadores</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.userBlackList.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block"
            >Bloquear Depósito de Terceiro</label
          >
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.featureFlagRefundPix.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block">Bloquear Saque para Terceiro</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.featureFlagCpfWithdraw.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block">Alta Performace de Saldo</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.featureFlagCustomerBalance.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block">Exibir Três Decimais</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.featureFlagNewParam.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block">Black List (MedPix)</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.blackList.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="isListCnpjExpanded"
      (opened)="openSection('listCnpj')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Lista CNPJ</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-3" formGroupName="listCnpj">
        <div class="col-md-6">
          <label class="form-label d-block">Bloquear Depósito via CNPJ</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="
                viewForm.controls.listCnpj.controls.flagCnpjCashIn.value
              "
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-6">
          <label class="form-label d-block">Bloquear Saque via CNPJ</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="
                viewForm.controls.listCnpj.controls.flagCnpjCashOut.value
              "
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-12">
          <label class="form-label d-block mb-2"
            >Lista de Cnpj Autorizados - Depósito</label
          >
          <div class="chip-list">
            <mat-chip-row
              *ngFor="
                let c of viewForm.controls.listCnpj.controls.cnpjCashIn.value ??
                  []
              "
            >
              {{ c }}
            </mat-chip-row>
          </div>
        </div>

        <div class="col-12">
          <label class="form-label d-block mb-2"
            >Lista de Cnpj Autorizados - Saque</label
          >
          <div class="chip-list">
            <mat-chip-row
              *ngFor="
                let c of viewForm.controls.listCnpj.controls.cnpjCashOut
                  .value ?? []
              "
            >
              {{ c }}
            </mat-chip-row>
          </div>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="isIpExpanded" (opened)="openSection('ip')">
      <mat-expansion-panel-header>
        <mat-panel-title>Lista de IP</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label d-block">Validar IP</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.validateIp.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-12">
          <label class="form-label d-block mb-2"
            >Lista de IPs Autorizados</label
          >

          <div
            class="chip-list"
            *ngIf="
              (viewForm.controls.listsIp.value ?? []).length > 0;
              else noIps
            "
          >
            <mat-chip-row
              *ngFor="let ip of viewForm.controls.listsIp.value ?? []"
            >
              {{ ip }}
            </mat-chip-row>
          </div>

          <ng-template #noIps>
            <span class="text-muted">Nenhum IP cadastrado</span>
          </ng-template>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      [expanded]="isCertificateExpanded"
      (opened)="openSection('certificate')"
    >
      <mat-expansion-panel-header>
        <mat-panel-title>Certificado mTLS</mat-panel-title>
      </mat-expansion-panel-header>

      <div class="row g-3" formGroupName="mtls">
        <div class="col-md-4">
          <label class="form-label d-block">Depósito</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.mtls.controls.deposit.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block">Saque</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.mtls.controls.withdraw.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>

        <div class="col-md-4">
          <label class="form-label d-block">TEF</label>
          <label class="custom-switch mt-2">
            <input
              type="checkbox"
              class="custom-switch-input"
              [checked]="viewForm.controls.mtls.controls.tef.value"
              disabled
            />
            <span class="custom-switch-indicator"></span>
          </label>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary btn-pill" (click)="dismiss()">
    Fechar
  </button>
</div>
